import { GET_ERP_ORDER_CANCEL_API_URL } from "../components/Shared/constant";

const ErpCancelOrderRetryAPI = async (payload, accessToken) => {
    const responce = window.axios.post(GET_ERP_ORDER_CANCEL_API_URL, payload, {
    headers: {
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default ErpCancelOrderRetryAPI;